import styled from "@emotion/styled";
import { useEffect, useRef } from "react";
import { Button } from "./Button";
import { CopyIcon } from "./CopyIcon";
import { FadeInContent } from "./FadeInContent";
import { Italic } from "./Italic";

const Container = styled.div`
  width: 100%;
  border-top: 1px solid #eaeaea;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  padding-bottom: 40px;
`;

const VenueImage = styled.div`
  background-image: url(/fi.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 300px;
`;

const Desc = styled.div`
  text-align: center;

  @media (max-width: 748px) {
   padding-left: 30px;
   padding-right: 30px;
  }
`;

const CopyRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

const SmallItalic = styled.span`
  font-style: italic;
  font-size: 0.8em;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export function WeddingPlace() {

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(()=>{
    if(!containerRef.current) return;
    const options = { //지도를 생성할 때 필요한 기본 옵션
      // @ts-ignore
      center: new kakao.maps.LatLng(37.511657786926726, 126.99494410780065), //지도의 중심좌표.
      level: 6//지도의 레벨(확대, 축소 정도)
    };
    // @ts-ignore
    const map = new kakao.maps.Map(containerRef.current, options); //지도 생성 및 객체 리턴
    // @ts-ignore
    var marker = new kakao.maps.Marker({ 
    // 지도 중심좌표에 마커를 생성합니다 
    position: map.getCenter() 
    });
    // 지도에 마커를 표시합니다
    marker.setMap(map);
  }, [])


  return (
    <Container>
      <FadeInContent
        style={{
          marginBottom: "20px",
        }}
      >
        <Italic>- Venue -</Italic>
      </FadeInContent>
      {/* <FadeInContent>
        <b>플로팅 아일랜드로 초대합니다</b>
      </FadeInContent> */}
      <FadeInContent>
        <div id="map" style={{
          width: "100%",
          height: "300px",
        }}
        ref={containerRef}
        ></div>
      </FadeInContent>

<FadeInContent>

  <Desc>
        <CopyRow>
          주소 : 서울 서초구 올림픽대로 2085-1
          <CopyIcon text="서울 서초구 올림픽대로 2085-14" />
        </CopyRow>
        <div>세빛섬 플로팅아일랜드 (반포동 650) 2층</div>
        <br />
        <SmallItalic>
          ✓ 고속터미널역 6번 출구 앞에서 무료 셔틀버스 10~15분 간격으로
          운행합니다.
        </SmallItalic>
        <br />
        <br />

        <SmallItalic>
          ✓ 주차 자리가 부족할 수 있으니 대중교통이나 택시를 추천 합니다!
        </SmallItalic>
      </Desc>
</FadeInContent>
      

      <FadeInContent
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
         <Button style={{ width: "80%" }} href="https://naver.me/GZAsttWP">
        지도 바로가기
      </Button>

      </FadeInContent>

      
    </Container>
  );
}
